import { Grid, Box } from '@mui/material';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import { useTheme } from '@mui/material/styles';
import {
	Link,
	useLocation
	// useNavigate
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
// import Scanner from 'components/icons';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { Language } from 'language';
import CircularProgress from '@mui/material/CircularProgress';
const BottomBarButtons = (props) => {
	const theme = useTheme();
	const location = useLocation();
	const { pathname } = location;
	const countries = useSelector((state) => state.activeCountry.data);
	const user = useSelector((state) => state.user.data);
	const [country, setCountry] = useState([]);

	useEffect(() => {
		if (countries) {
			setCountry(countries?.find((country) => country.short_code === user.country_short_code));
		}
	}, [user, countries]);

	const isPathSelected = (path) => {
		const styles = {
			backgroundColor: "#EEF3FF",
			borderRadius: "15px",
			fontWeight: "bold",
			color: '#467CEB'
		};
		return pathname.includes(path) ? styles : {};
	};
	return (
		<Grid
			container
			spacing={1}
			sx={{
				position: 'fixed',
				maxWidth: '100%',
				background: theme.palette.background.paper,
				borderTop: `1px solid ${theme.palette.divider}`,
				right: 0,
				zIndex: 400,
				bottom: "0px"
			}}
			padding={0.5}
		>
			<Grid item xs={2.4} display="flex" justifyContent="center" alignItems="center">
				<Box
					component={Link}
					to="/home"
					sx={{
						textDecoration: 'none',
						color: "#000",
						background: "white",
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						'&:hover': { backgroundColor: 'white' }, // Prevents hover color change
						'&:focus': { backgroundColor: 'white' }, // Prevents focus outline behavior
						'&:active': { backgroundColor: 'white' } // Prevents bg color flicker on click
					}}
				>
					<Grid
						item
						xs={12}
						mb={1}
						sx={{
							padding: "6px 20px",
							background: isPathSelected('/home')?.backgroundColor || 'transparent',
							borderRadius: isPathSelected('/home')?.borderRadius || '0',
							color: isPathSelected('/home')?.color || '#000',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center'
						}}
					>
						<LocationOnOutlinedIcon />
					</Grid>
					<Grid
						item
						xs={12}
						sx={{
							fontSize: '12px',
							fontWeight: isPathSelected('/home')?.fontWeight || 'normal',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center'
						}}
					>
						{Language.heading.map}
					</Grid>
				</Box>
			</Grid>

			{country?.is_shop_enabled == undefined ? (
				<Grid item xs={2.4} display="flex" justifyContent="center" alignItems="center">
					<CircularProgress size="30px" />
				</Grid>
			) : (
				<Grid item xs={2.4} display="flex" justifyContent="center" alignItems="center">
					<Grid
						container
						display="flex"
						justifyContent="center"
						alignItems="center"
						component={Link}

						to={country?.is_shop_enabled ? '/shop' : '/charging-history'}
						sx={{
							color: theme.palette.text.primary,
							textDecoration: 'none',
						}}
					>
						<Grid item xs={12} display="flex" justifyContent="center" alignItems="center" mb={1} sx={{ textDecoration: 'none', padding: "6px 20px", background: isPathSelected(country?.is_shop_enabled ? '/shop' : '/charging-history').backgroundColor, borderRadius: isPathSelected(country?.is_shop_enabled ? '/shop' : '/charging-history').borderRadius, color: isPathSelected(country?.is_shop_enabled ? '/shop' : '/charging-history').color }}>
							{country?.is_shop_enabled ? (
								<ShoppingCartOutlinedIcon />
							) : (
								<ElectricBoltIcon />
							)}
						</Grid>
						<Grid item xs={12} sx={{ fontSize: '12px', fontWeight: isPathSelected(country?.is_shop_enabled ? '/shop' : '/charging-history').fontWeight }} display="flex" justifyContent="center" alignItems="center">
							{country?.is_shop_enabled ? Language.heading.shop : Language.heading.history}
						</Grid>
					</Grid>
				</Grid>
			)}

			<Grid item xs={2.4} display="flex" justifyContent="center" alignItems="center">
				<Grid
					container
					display="flex"
					justifyContent="center"
					alignItems="center"
					component={Link}
					onClick={props.qr}
					to="/qr-scanner"
					sx={{
						color: theme.palette.text.primary,
						textDecoration: 'none',
						background: isPathSelected('/qr-scanner').backgroundColor,
						cursor: 'pointer'
					}}
				>
					<Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
						<Grid container>
							<Grid
								item
								xs={12}
								display="flex"
								justifyContent="center"
								alignItems="center"
								sx={{
									backgroundColor: 'black',
									color: 'white',
									position: 'absolute',
									height: '70px',
									width: '70px',
									borderRadius: '100%',
									top: -20,
									border: '2px solid rgb(255,255,255)',
									boxShadow: '1px 1px 10px rgba(0, 0, 0, 0.7)'
								}}
							>
								<QrCodeScannerIcon sx={{ color: 'white' }}></QrCodeScannerIcon>
							</Grid>
						</Grid>
						{/* <div style={{ position: 'relative', top: -20, background: 'black', borderRadius: '50%', width: '100%' }}>
								<CropFreeIcon sx={{ height: '50px', color: theme.palette.common.white }}></CropFreeIcon>
							</div> */}
						{/* <img src={scanner} alt="scanner" style={{ position: 'absolute', top: -55, height: 120}}></img> */}
					</Grid>
					{/* <Grid item xs={12} sx={{ fontSize: '12px' }} display="flex" justifyContent="center" alignItems="center">
							Scanner
						</Grid> */}
				</Grid>
			</Grid>
			<Grid item xs={2.4}>
				<Grid
					container
					display="flex"
					justifyContent="center"
					alignItems="center"
					component={Link}
					to="/wallet"
					sx={{ color: theme.palette.text.primary, textDecoration: 'none' }}
				>
					<Grid item xs={12} display="flex" justifyContent="center" alignItems="center" mb={1} sx={{ textDecoration: 'none', padding: "6px 20px", background: isPathSelected('/wallet').backgroundColor, borderRadius: isPathSelected('/wallet').borderRadius, color: isPathSelected('/wallet').color }}>
						<AccountBalanceWalletIcon></AccountBalanceWalletIcon>
					</Grid>
					<Grid item xs={12} sx={{ fontSize: '12px', fontWeight: isPathSelected('/wallet').fontWeight }} display="flex" justifyContent="center" alignItems="center">
						{Language.heading.wallet}
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={2.4} display="flex" justifyContent="center" alignItems="center">
				<Grid
					container
					display="flex"
					justifyContent="center"
					alignItems="center"
					component={Link}
					to="/profile"
					sx={{ color: theme.palette.text.primary, textDecoration: 'none' }}
				>
					<Grid item xs={12} display="flex" justifyContent="center" alignItems="center" mb={1} sx={{ textDecoration: 'none', padding: "6px 20px", background: isPathSelected('/profile').backgroundColor, borderRadius: isPathSelected('/profile').borderRadius, color: isPathSelected('/profile').color }}>
						<AccountCircleOutlinedIcon></AccountCircleOutlinedIcon>
					</Grid>
					<Grid item xs={12} sx={{ fontSize: '12px', fontWeight: isPathSelected('/profile').fontWeight }} display="flex" justifyContent="center" alignItems="center">
						{Language.heading.profile}
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default BottomBarButtons;
